var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=index.es345.js.map
